import { Dimensions, StyleSheet } from 'react-native';

import { heightPercentageToDP } from 'utils/responsiveness';

import { SIZES as CHANNEL_SIZES, SIZES } from './ChannelItem/styles';

const styles = StyleSheet.create({
    root: {
        height: CHANNEL_SIZES.heightSelected + CHANNEL_SIZES.spacing * 2,
        justifyContent: 'center',
        alignItems: 'center',
    },
    carouselContainer: {
        width: Dimensions.get('window').width,
        height: heightPercentageToDP(115),
        justifyContent: 'center',
        alignItems: 'center',
    },
    webList: {
        height: heightPercentageToDP(115),
    },
    webListContainer: {
        flexGrow: 1,
        // width: Dimensions.get('window').width,
        // height: heightPercentageToDP(115),
        justifyContent: 'center',
        alignItems: 'center',
    },
    arrow: { height: heightPercentageToDP(115) },
    arrowFwd: { paddingBottom: 0 },
    arrowBwd: { paddingTop: 0 },
    list: {
        width: '100%',
        paddingVertical: 10,
    },
    loadingList: {
        width: '100%',
        paddingVertical: 10,
        opacity: 0,
    },
    finiteListHeaderFooter: {
        width: 56,
    },
    finiteListContainerStyle: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    finiteListSeparator: {
        width: SIZES.spacing,
    },
    finiteListChannel: {
        marginHorizontal: 0,
    },
    finiteListChannelSelected: {
        marginLeft: 0,
    },
    skeletonContainer: StyleSheet.absoluteFillObject,
});

export default styles;
